import { useState } from 'react';
// @mui
import { Avatar, Box, Divider, MenuItem, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
//
import { useAuth0 } from '@auth0/auth0-react';
import { useSnackbar } from 'notistack';
import useCreateBillingPortal from 'src/hooks/core-api/useBillingPortal';
import useCurrentUser from 'src/hooks/core-api/useCurrentUser';
import { IconButtonAnimate } from '../../../components/animate';
import MenuPopover from '../../../components/MenuPopover';

// ----------------------------------------------------------------------

const AccountPopover: React.FC<{}> = () => {
  const [open, setOpen] = useState<HTMLElement | null>(null);
  const { enqueueSnackbar } = useSnackbar();
  const currentUserQuery = useCurrentUser();
  const createBillingPortalMutation = useCreateBillingPortal();
  const { logout } = useAuth0();

  const currentUser = currentUserQuery?.data;
  const { first_name, last_name, email, avatar_url, role } = currentUser ?? {};
  const full_name = `${first_name} ${last_name}`;

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleViewBillingPortal = () => {
    createBillingPortalMutation.mutate(
      {},
      {
        onSuccess: (data) => window.location.replace(data.portal_url),
        onError: (error) => {
          const errorMessage = `Failed to load billing portal.`;
          enqueueSnackbar(errorMessage, {
            variant: 'error',
          });
        },
      }
    );
  };

  const handleLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={avatar_url} alt={full_name} />
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {full_name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {/* Dashboard Pages */}
        <Stack sx={{ p: 1 }}>
          {role === 'admin' && <MenuItem onClick={handleViewBillingPortal}>Billing</MenuItem>}
          <Divider sx={{ borderStyle: 'dashed' }} />
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Stack>
      </MenuPopover>
    </>
  );
};

export default AccountPopover;
